import { createAsyncThunk } from "@reduxjs/toolkit";
import { API, API_URL } from "../../../config/api";
import axiosService from "../../../services/axiosServicesVisit";

const api_url = API_URL + API.SAMPLE.GETSAMPLES;

export const getSamples = createAsyncThunk(
  'samples/getSamples',
  async (paramsData = {}, thunkAPI) => {
    const { page = 1, itemsPerPage, limit, filter = {} } = paramsData;
    try {
      const finalLimit = limit || itemsPerPage || 10;
      
      const params = new URLSearchParams({
        page: page,
        limit: finalLimit,
      });

      if (filter.search) {
        params.append('search', filter.search);
      }

      const queryString = params.toString();
      const response = await axiosService.get(`${api_url}?${queryString}`);
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response?.data || 'An error occurred');
    }
  }
);

export const addSample = createAsyncThunk(
  "samples/addProduct",
  async (samplesData, thunkAPI) => {
    try {
      const response = await axiosService.post(api_url, samplesData);
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response.data);
    }
  }
);

export const deleteSamples = createAsyncThunk(
  "samples/deleteSample",
  async (id, thunkAPI) => {
    try {
      const response = await axiosService.delete(`${api_url}/${id}`);
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response.data);
    }
  }
);

export const updateSample = createAsyncThunk(
  "samples/updateSample",
  async ({ id, samplesData }, thunkAPI) => {
    try {
      const response = await axiosService.patch(`${api_url}/${id}`, samplesData);
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response.data);
    }
  }
);

export const getSampleByID = createAsyncThunk(
  "samples/getSampleByID",
  async (id, thunkAPI) => {
    try {
      const response = await axiosService.get(`${api_url}/${id}`);
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response.data);
    }
  }
);

export const importSamples = createAsyncThunk(
  "samples/importSamples",
  async (data, thunkAPI) => {
    try {
      const response = await axiosService.post(`${api_url}/import?format=csv`, data);
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response.data);
    }
  }
);